import React from 'react';

import { CategoryItem } from '~/components/side-navigation';
import { Tooltip, TooltipTrigger } from '~/components/tooltip/Tooltip';

import * as S from './NavItem.styles';

export type NavItemProps = {
  item: CategoryItem;
  activeSubKey?: string;
  sideBarExpanded: boolean;
};

export const NavItem = ({
  item,
  activeSubKey,
  sideBarExpanded,
}: NavItemProps) => {
  return (
    <Tooltip
      label={item.label}
      disabled={sideBarExpanded}
      trigger={TooltipTrigger.Hover}
      placement="right"
    >
      <S.SubItem
        key={item.key}
        $isActive={activeSubKey === item.key}
        $sideBarExpanded={sideBarExpanded}
        data-testid={`subitem-${item.key}`}
        onClick={() => {
          item.onClick?.(item);
        }}
      >
        {item.icon && (
          <>
            <S.IconWrapper>{item.icon}</S.IconWrapper>
            {sideBarExpanded && <S.MainLabel>{item.label}</S.MainLabel>}
          </>
        )}
        {!item.icon && (
          <S.MainLabel>
            {sideBarExpanded ? item.label : item.label.charAt(0).toUpperCase()}
          </S.MainLabel>
        )}
        {sideBarExpanded && item.badge}
      </S.SubItem>
    </Tooltip>
  );
};

NavItem.Styled = S;
